export const environment = {
    production: true,
    apiBaseUrl: '/album-api',
    apiBaseCommerceUrl: '/album-api/commerce',
    // apiBaseUrl: 'https://sisufoto.dk/album-api',
    // apiBaseCommerceUrl: 'https://sisufoto.dk/album-api/commerce',
    immichBaseUrl: 'https://immich.bystrup.net',
    useImmich: false,
    googleTagMeasurementId: 'G-B5MECYPD3W'
};
